query GetFundAccountAverageMonthlyBalances(
  $fundAccountId: ID!
  $page: Int
  $limit: Int
  $sortBy: String
) {
  fundAccountAverageMonthlyBalances(
    fundAccountId: $fundAccountId
    page: $page
    limit: $limit
    sortBy: $sortBy
  ) {
    collection {
      id
      startDate
      endDate
      monthEndBalance {
        minorUnit
        currency
      }
      averageDailyBalance {
        minorUnit
        currency
      }
      averageDailyLiquidBalance {
        minorUnit
        currency
      }
      hifoTotal {
        minorUnit
        currency
      }
      opexTotal {
        minorUnit
        currency
      }
      dailyBalances {
        date
        balance {
          minorUnit
          currency
        }
        opexTotal {
          minorUnit
          currency
        }
        hifoTotal {
          minorUnit
          currency
        }
      }
      dafPlan
      investmentAllocation
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
